import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { SortableContainer } from 'react-sortable-hoc';

// actions
import { showModal } from '../../../../../actions/ModalActions';
import { getTravel, editTravel } from '../../../../../actions/website/entities/TravelActions';
import { moveEntity, resetEntities, addEntity } from '../../../../../actions/website/EntityActions';

import { togglePage } from '../../../../../actions/website/PageActions';
import EditPageForm from '../EditPageCommon/EditPageForm';
import EditPageHeader from '../EditPageCommon/EditPageHeader';
import EditPageAddEntity from '../EditPageCommon/EditPageAddEntity';
import TravelDetails from './TravelDetails';
import AddButtons from './AddButtons';

class Travel extends Component {
  componentDidMount() {
    const { getTravelEntities } = this.props;
    getTravelEntities();
  }

  componentWillUnmount() {
    const { unloadEntities } = this.props;
    unloadEntities();
  }

  render() {
    const {
      travelEntities,
      orderedIds,
      openModal,
      onEdit,
      onDelete,
      page,
      themeKey,
      onPageToggle,
    } = this.props;
    const pageType = page && page.type;
    return (
      <div>
        <EditPageHeader
          entityName="Travel & Places To Stay"
          onAdd={openModal}
          page={page}
          themeKey={themeKey}
          onPageToggle={onPageToggle}
        />

        <>
          <EditPageForm page={page} />
          <EditPageAddEntity
            entitiesListTitle="Your Places"
            entityName="Travel & Places To Stay"
            onAddButton={<AddButtons onAdd={openModal} />}
            pageType={pageType}
            orderedIds={orderedIds}
            entities={travelEntities}
            onAdd={openModal}
            onEdit={onEdit}
            onDelete={onDelete}
            entityDetail={TravelDetails}
          />
        </>
      </div>
    );
  }
}

Travel.propTypes = {
  travelEntities: PropTypes.shape({}),
  orderedIds: PropTypes.arrayOf(PropTypes.number),
  getTravelEntities: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  unloadEntities: PropTypes.func.isRequired,
  page: PropTypes.shape({}),
  themeKey: PropTypes.string,
  onPageToggle: PropTypes.func,
};

const mapStateToProps = state => ({
  travelEntities: state.website.entities.byId,
  orderedIds: state.website.entities.orderedIds,
  page: state.website.pages.byId[state.website.pages.typeToId.TRAVEL],
  themeKey: state.wedding.theme.key,
});

const mapDispatchToProps = dispatch => ({
  onSortEnd: ({ oldIndex, newIndex }) => {
    dispatch(moveEntity(oldIndex, newIndex));
  },
  openModal: () => {
    dispatch(addEntity());
    dispatch(showModal('TRAVEL', { formIdentifier: 'travelForm' }, { size: 'md' }));
  },
  getTravelEntities: () => {
    dispatch(getTravel());
  },
  onEdit: travel => {
    dispatch(editTravel(travel));
    dispatch(showModal('TRAVEL', { isUpdate: true, formIdentifier: 'travelForm' }, { size: 'md' }));
  },
  onDelete: entity => {
    dispatch(showModal('DELETE_ENTITY', { entity }));
  },
  unloadEntities: () => {
    dispatch(resetEntities());
  },
  onPageToggle: pageId => dispatch(togglePage(pageId)),
});

const SortableTravel = SortableContainer(Travel);

const TravelContainer = connect(mapStateToProps, mapDispatchToProps)(SortableTravel);

export default TravelContainer;



// WEBPACK FOOTER //
// ./src/components/manage/website/entities/Travel/Travel.jsx